import { Link } from "react-router-dom";

import { BuildingIcon, ListIcon, ScanSearchIcon } from "@lucide/icons";
import { useQuery } from "@tanstack/react-query";

import { initUseQuery } from "simplydo/core/query";
import { Button, ButtonLink } from "simplydo/react/ui/button";
import { Divider } from "simplydo/react/ui/divider";
import { Icon } from "simplydo/react/ui/icon";

import api from "api";
import { useAppSelector } from "store";
import util from "utils/utils";

import RowComponent from "components/lib/RowComponent";

const HomeInnovationIntelligence = () => {
  const user = useAppSelector((state) => state.user);

  const innoIntelEnabled =
    util.organisationFeaturesEnabled(user, ["innovationIntelligence"]) &&
    util.hasPermission(
      user,
      "org.innovationIntelligence",
      user?.ownerOrganisation?._id,
    );

  const myListsQuery = useQuery(
    initUseQuery(api.innointel.getLists, [], { isEnabled: innoIntelEnabled }),
  );

  if (!innoIntelEnabled) return null;
  return (
    <RowComponent>
      <RowComponent.Fill>
        <RowComponent.Title
          to="/innointel"
          wrapping
          style={{ textDecoration: "none" }}
        >
          Innovation Intelligence
        </RowComponent.Title>
        <ButtonLink size="small" color="primary" to="/innointel">
          View companies
        </ButtonLink>
      </RowComponent.Fill>
      <RowComponent.Cell asChild>
        <Link to={"/innointel"}>
          <Icon icon={BuildingIcon} size="large" />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: 5,
              marginRight: 5,
              position: "relative",
              top: -1,
            }}
          >
            <RowComponent.Title style={{ color: "#5d5d5d" }} block>
              Business Search
            </RowComponent.Title>
            <RowComponent.StatusArea>
              Companies and organisations worldwide
            </RowComponent.StatusArea>
          </div>
        </Link>
      </RowComponent.Cell>
      <RowComponent.Cell asChild>
        <Link to="/innointel/dashboards/">
          <Icon icon={ScanSearchIcon} size="large" />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginLeft: 5,
              marginRight: 5,
              position: "relative",
              top: -1,
            }}
          >
            <RowComponent.Title style={{ color: "#5d5d5d" }} block>
              Industry Dashboards
            </RowComponent.Title>
            <RowComponent.StatusArea>
              Innovation landscape of a specific industry
            </RowComponent.StatusArea>
          </div>
        </Link>
      </RowComponent.Cell>

      {(myListsQuery.data?.lists?.length ?? 0) > 0 ? (
        <>
          <Divider hidden />
          <RowComponent.Fill>
            <RowComponent.Title>Your company lists</RowComponent.Title>
          </RowComponent.Fill>
          {myListsQuery.data?.lists.map((list) => (
            <RowComponent.Cell
              key={list._id}
              style={{ padding: "5px 5px" }}
              asChild
            >
              <Link to={`/innointel/lists/${list._id}`}>
                <Icon icon={ListIcon} size="large" />
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    marginLeft: 5,
                    marginRight: 5,
                    position: "relative",
                    top: -1,
                  }}
                >
                  <RowComponent.Title style={{ color: "#5d5d5d" }} block>
                    {list.name}
                  </RowComponent.Title>
                  <RowComponent.StatusArea>
                    {list.companies?.length ?? 0} companies
                    {user && (list as { user?: string }).user !== user._id
                      ? ", shared with you."
                      : ""}
                  </RowComponent.StatusArea>
                </div>
              </Link>
            </RowComponent.Cell>
          ))}
        </>
      ) : null}
    </RowComponent>
  );
};

export default HomeInnovationIntelligence;
